import { featureFlags } from '../config/featureFlags'

/** Standards with backend corpus adapter (must match CONTROL_CENTRIC_SUPPORTED_STANDARDS). */
export const CONTROL_CENTRIC_SUPPORTED_STANDARDS = [
  'SOC2',
  'ISO27001',
  'ISO42001',
  'GDPR',
  'NIS2',
  'CIS',
] as const

export function normalizeJourneyStandardCode(raw: string): string {
  const s = String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_')
  if (s === 'ISO_27001') return 'ISO27001'
  if (s === 'ISO_42001' || s === 'ISO42001_2023') return 'ISO42001'
  if (s === 'CIS_V8' || s === 'CIS_CONTROLS' || s === 'CIS_CONTROLS_V8') return 'CIS'
  return s
}

export function isControlCentricSupportedStandard(standardCode: string): boolean {
  return CONTROL_CENTRIC_SUPPORTED_STANDARDS.includes(
    normalizeJourneyStandardCode(standardCode) as (typeof CONTROL_CENTRIC_SUPPORTED_STANDARDS)[number],
  )
}

export function isControlCentricUxEnabledForStandard(standardCode: string, standardAllowed = true): boolean {
  if (!standardAllowed) return false
  const code = normalizeJourneyStandardCode(standardCode)
  if (featureFlags.STANDARD_CONTROL_CENTRIC_UX_V1) {
    return isControlCentricSupportedStandard(code)
  }
  return featureFlags.CONTROL_CENTRIC_WORKFLOW_UX_V2 && code === 'SOC2'
}

export function isAnyControlCentricUxFlagOn(): boolean {
  return featureFlags.STANDARD_CONTROL_CENTRIC_UX_V1 || featureFlags.CONTROL_CENTRIC_WORKFLOW_UX_V2
}
